var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
export const RadioButtonInput = forwardRef((_a, ref) => {
    var { label, type, options } = _a, rest = __rest(_a, ["label", "type", "options"]);
    return (_jsxs(Row, Object.assign({ className: 'radio-button-container' }, { children: [_jsx(Col, Object.assign({ xs: 12 }, { children: _jsx("label", Object.assign({ className: 'form-label' }, { children: label })) })), _jsx(Row, Object.assign({ className: 'radio-button-group primary' }, { children: options === null || options === void 0 ? void 0 : options.map(({ label: optionLabel, value }) => {
                    var _a;
                    return (_jsx(Col, { children: _jsx(Button, Object.assign({ variant: 'primary', className: 'btn filter-button text-center w-100', onClick: () => rest.onChange(value), active: ((_a = rest.value) === null || _a === void 0 ? void 0 : _a.toString()) === (value === null || value === void 0 ? void 0 : value.toString()) }, { children: optionLabel })) }, optionLabel));
                }) }))] })));
});
RadioButtonInput.displayName = 'RadioButtonInput';
